module.exports = __webpack_public_path__ + "media/assets/site_images/photos_gallery/photo1-c701757ae477ab78349abf950d08ac58.jpg";